import { useTranslation } from 'react-i18next';
import { viewSettingsRequest } from '../../list/savedViews/viewSettingsRequest';
import type { IGridHiddenNoteProps } from './IGridHiddenNoteProps';

/**
 * «Приховано стовпців: N — не вміщуються за шириною · Виберіть стовпці в налаштуваннях подання» (прототип v4: 12px, приглушений, над сіткою);
 * друга частина відкриває «Налаштування подання» зі списком стовпців.
 */
export function GridHiddenNote({ count }: IGridHiddenNoteProps) {
  const { t } = useTranslation();
  if (count <= 0) return null;
  return (
    <div className="rg__note" role="note">
      {t('listViews.hiddenCols', { count })} · <button type="button" className="rg__note-link" onClick={viewSettingsRequest.request}>{t('listViews.chooseCols')}</button>
    </div>
  );
}
